export const HEATMAP_WEIGHT_PROPERTY = '__heatmapWeight';
export const HEATMAP_NORMALIZED_WEIGHT_PROPERTY = '__heatmapWeightNormalized';
export const HEATMAP_MIN_ZOOM = 0;
export const HEATMAP_MAX_ZOOM = 24;
export const CLUSTER_MAX_ZOOM = 6;
export const CLUSTER_RADIUS = 36;
export const CLUSTER_FADE_OUT_START_ZOOM = 5;
export const CLUSTER_FADE_OUT_END_ZOOM = 7;
export const HEATMAP_VISIBLE_START_ZOOM = 4;
export const HEATMAP_VISIBLE_FULL_ZOOM = 6;
